<template>
  <SettingsSection :title="$t(`platform.card.code.${isSite ? 'code' : 'link'}_title`)" :description="$t(`platform.card.code.${isSite ? 'code' : 'link'}_description`)">
    <div v-if="dirty" class="sat-note _warn mb-4">
      <SatIcon name="alert" :size="16" />
      <span>{{ $t("platform.card.code.unsaved") }}</span>
    </div>
    <PlatformModal :platform="platform" embedded :showSettingsLink="false" />
  </SettingsSection>
</template>
<script>
import PlatformModal from "@/components/PlatformModal.vue";
import SatIcon from "@/components/Satellites/SatIcon.vue";
import SettingsSection from "@/components/PlatformCard/SettingsSection.vue";

// The code to put on a site or the link of an arbitrage platform: the "get code" modal of the list, on the card.
export default {
  name: "CodeTab",
  components: { PlatformModal, SatIcon, SettingsSection },
  props: {
    // The saved sub-account with its id; the domain and redirect switches of the code are saved at once
    platform: {
      type: Object,
      required: true,
    },
    isSite: {
      type: Boolean,
      default: false,
    },
    // The card has unsaved changes, which the code does not have yet
    dirty: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
